import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import User from '@/types/user'

interface UpdateProjectSharePayload {
  project: {
    id: number
    company_id: number
    name: string
    private: boolean
  }
  users: Omit<User, 'exp'>[]
}

export const updateProjectShare = async (
  payload: UpdateProjectSharePayload,
) => {
  const { data } = await companiesApi.patch(
    apiRoutes.updateProjectShare,
    payload,
  )

  return data
}
